// import { useState, useMemo, useCallback, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Edit, Eye, Trash2, Loader2, Plus } from "lucide-react";
// import { Button } from "@/components/ui/button";
// import { Badge } from "@/components/ui/badge";
// import {
//   Table,
//   TableBody,
//   TableCaption,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "@/components/ui/table";
// import { Input } from "@/components/ui/input";
// import { toast } from "sonner";
// import {
//   useGetCoursesQuery,
//   useDeleteCourseMutation,
// } from "@/features/api/courseApi";

// const CoursesList = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [sortBy, setSortBy] = useState("updatedAt");
//   const [sortOrder, setSortOrder] = useState("desc");

//   const navigate = useNavigate();


//   // Fetch courses
// const { data, isLoading, isFetching, isError, error } =
//   useGetCoursesQuery(undefined, {
//     refetchOnMountOrArgChange: true,
//     refetchOnFocus: true,
//     refetchOnReconnect: true,
//   });

//   const [deleteCourse, { isLoading: isDeleting }] = useDeleteCourseMutation();

//   // Normalize API data
//   const courses = useMemo(
//     () => (Array.isArray(data?.courses) ? data.courses : []),
//     [data]
//   );

//   // Sort courses
//   const filteredCourses = useMemo(() => {
//   if (!courses.length) return [];

//   return courses.filter((course) => {
//     if (!searchQuery) return true;

// const q = searchQuery.trim().toLowerCase();
//     return (
//       course.title?.toLowerCase().includes(q) ||
//       course.slug?.toLowerCase().includes(q)
//     );
//   });
// }, [courses, searchQuery]);

// const sortedCourses = useMemo(() => {
//   return [...filteredCourses].sort((a, b) => {
//     let aVal, bVal;

//     switch (sortBy) {
//       case "title":
//         aVal = a.title || "";
//         bVal = b.title || "";
//         break;

//       case "slug":
//         aVal = a.slug || "";
//         bVal = b.slug || "";
//         break;

//       case "status":
//         aVal = a.status || "";
//         bVal = b.status || "";
//         break;

//       case "updatedAt":
//       default:
//         aVal = new Date(a.updatedAt ?? 0).getTime();
//         bVal = new Date(b.updatedAt ?? 0).getTime();
//     }

//     if (typeof aVal === "string") {
//       return sortOrder === "asc"
//         ? aVal.localeCompare(bVal)
//         : bVal.localeCompare(aVal);
//     }

//     return sortOrder === "asc" ? aVal - bVal : bVal - aVal;
//   });
// }, [filteredCourses, sortBy, sortOrder]);

//   // Toggle sorting
//  const toggleSortOrder = useCallback((field) => {
//   setSortBy(field);

//   setSortOrder((prev) =>
//     field === sortBy
//       ? prev === "asc" ? "desc" : "asc"
//       : "asc"
//   );
// }, [sortBy]);

//   // Preview handler
//   const handlePreview = (e, course) => {
//     e.stopPropagation();
//     const previewUrl = `${window.location.origin}/courses/${course.slug}${
//       course.status === "published" ? "" : "?preview=true"
//     }`;
//     window.open(previewUrl, "_blank");
//   };

//   // Delete handler
//   const handleDelete = async (e, slug) => {
//     e.stopPropagation();
//     if (!slug) return;
//     if (window.confirm("Are you sure you want to delete this course?")) {
//       try {
//         await deleteCourse(slug).unwrap();
//         toast.success("Course deleted successfully");
//       } catch (err) {
//         toast.error(err?.data?.message || "Failed to delete course");
//       }
//     }
//   };

//   // Format date
//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     const d = new Date(date);
//     return isNaN(d) ? "N/A" : d.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   // Error handling
//   useEffect(() => {
//     if (isError) {
//       if (error?.status === 401) {
//         toast.error("Session expired. Please log in again.");
//         navigate("/login");
//       } else {
//         toast.error(error?.data?.message || "Failed to fetch courses");
//       }
//     }
//   }, [isError, error, navigate]);

//   return (
//     <div className="flex-1 p-6 bg-background min-h-screen">
//       <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
//         <h2 className="text-2xl font-semibold">📚 All Courses</h2>
//         <Button
//           onClick={() => navigate("/admin/courses/create")}
//           className="flex items-center gap-2"
//           aria-label="Create new course"
//         >
//           <Plus size={18} />
//           Create New Course
//         </Button>
//       </div>

//       <Input
//         type="text"
//         placeholder="Search by Title or Slug"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//         className="mb-6 max-w-md"
//         aria-label="Search courses"
//       />

//       {isError ? (
//         <div className="text-center text-red-500">
//           {error?.data?.message || "Failed to fetch courses"}
//           <br />
//           <Button onClick={() => window.location.reload()} variant="link">
//             Retry
//           </Button>
//         </div>
//       ) : isLoading || isFetching ? (
//         <div className="text-center flex items-center justify-center gap-2">
//           <Loader2 className="w-5 h-5 animate-spin" /> Loading courses...
//         </div>
//       ) : sortedCourses.length === 0 ? (
//         <div className="text-center text-gray-500">📭 No courses found</div>
//       ) : (
//         <Table>
//           <TableCaption>List of all created courses</TableCaption>
//           <TableHeader>
//             <TableRow>
//               <TableHead
//                 onClick={() => toggleSortOrder("title")}
//                 className="cursor-pointer"
//               >
//                 Title {sortBy === "title" && (sortOrder === "asc" ? "↑" : "↓")}
//               </TableHead>
//               <TableHead
//                 onClick={() => toggleSortOrder("slug")}
//                 className="cursor-pointer"
//               >
//                 Slug {sortBy === "slug" && (sortOrder === "asc" ? "↑" : "↓")}
//               </TableHead>
//               <TableHead
//                 onClick={() => toggleSortOrder("status")}
//                 className="cursor-pointer"
//               >
//                 Status {sortBy === "status" && (sortOrder === "asc" ? "↑" : "↓")}
//               </TableHead>
//               <TableHead
//                 onClick={() => toggleSortOrder("updatedAt")}
//                 className="cursor-pointer"
//               >
//                 Updated On {sortBy === "updatedAt" && (sortOrder === "asc" ? "↑" : "↓")}
//               </TableHead>
//               <TableHead className="text-right">Actions</TableHead>
//             </TableRow>
//           </TableHeader>
//           <TableBody>
//             {sortedCourses.map((course) => (
//               <TableRow
//                 key={course.slug}
//                 onClick={() => navigate(`/admin/courses/${course.slug}/edit`)}
//                 className="hover:bg-accent/30 cursor-pointer transition"
//               >
//                 <TableCell className="font-medium truncate max-w-xs">
//                   {course.title || "Untitled"}
//                 </TableCell>
//                 <TableCell className="text-sm text-muted-foreground">
//                   {course.slug || "N/A"}
//                 </TableCell>
//                 <TableCell>
//                   <Badge
//                     className={
//                       course.status === "published" ? "bg-green-600" : "bg-yellow-500"
//                     }
//                   >
//                     {course.status === "published" ? "Published" : "Draft"}
//                   </Badge>
//                 </TableCell>
//                 <TableCell>{formatDate(course.updatedAt)}</TableCell>
//                 <TableCell
//                   className="text-right flex gap-2 justify-end"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <Button
//                     variant="outline"
//                     size="icon"
//                     onClick={() => navigate(`/admin/courses/${course.slug}/edit`)}
//                     title="Edit Course"
//                     aria-label={`Edit course ${course.title || "Untitled"}`}
//                   >
//                     <Edit size={18} />
//                   </Button>
//                   <Button
//                     variant="outline"
//                     size="icon"
//                     onClick={(e) => handlePreview(e, course)}
//                     title="Preview Course"
//                     aria-label={`Preview course ${course.title || "Untitled"}`}
//                   >
//                     <Eye size={18} />
//                   </Button>
//                   <Button
//                     variant="destructive"
//                     size="icon"
//                     onClick={(e) => handleDelete(e, course.slug)}
//                     disabled={isDeleting}
//                     title="Delete Course"
//                     aria-label={`Delete course ${course.title || "Untitled"}`}
//                   >
//                     <Trash2 size={18} />
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       )}
//     </div>
//   );
// };

// export default CoursesList;


import React, { useState, useMemo, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Edit, Eye, Trash2, Loader2, Plus, ArrowUp, ArrowDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";

import {
  useGetCoursesQuery,
  useDeleteCourseMutation,
} from "@/features/api/courseApi";

const CoursesList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const navigate = useNavigate();

  /* ================= API CALLS ================= */
  const { data, isLoading, isFetching, isError, error } = useGetCoursesQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const [deleteCourse, { isLoading: isDeleting }] = useDeleteCourseMutation();

  const courses = useMemo(() => {
    return Array.isArray(data?.courses) ? data.courses : [];
  }, [data]);

  /* ================= FILTER & SORT ================= */
  const filteredCourses = useMemo(() => {
    if (!searchQuery.trim()) return courses;

    const q = searchQuery.trim().toLowerCase();
    return courses.filter((course) =>
      course.title?.toLowerCase().includes(q) ||
      course.slug?.toLowerCase().includes(q)
    );
  }, [courses, searchQuery]);

  const sortedCourses = useMemo(() => {
    return [...filteredCourses].sort((a, b) => {
      let aVal, bVal;

      switch (sortBy) {
        case "title":
          aVal = a.title?.toLowerCase() || "";
          bVal = b.title?.toLowerCase() || "";
          return sortOrder === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);

        case "slug":
          aVal = a.slug?.toLowerCase() || "";
          bVal = b.slug?.toLowerCase() || "";
          return sortOrder === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);

        case "status":
          aVal = a.status || "";
          bVal = b.status || "";
          return sortOrder === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);

        case "updatedAt":
        default:
          aVal = new Date(a.updatedAt || 0).getTime();
          bVal = new Date(b.updatedAt || 0).getTime();
          return sortOrder === "asc" ? aVal - bVal : bVal - aVal;
      }
    });
  }, [filteredCourses, sortBy, sortOrder]);

  /* ================= HANDLERS ================= */
  const toggleSort = useCallback((field) => {
    if (sortBy === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(field);
      setSortOrder("desc");
    }
  }, [sortBy]);

  const handlePreview = (e, course) => {
    e.stopPropagation();
    const previewUrl = `${window.location.origin}/courses/${course.slug}${
      course.status !== "published" ? "?preview=true" : ""
    }`;
    window.open(previewUrl, "_blank");
  };

  const handleDelete = async (e, slug) => {
    e.stopPropagation();
    if (!slug) return;

    if (!window.confirm("Are you sure you want to permanently delete this course?")) {
      return;
    }

    try {
      await deleteCourse(slug).unwrap();
      toast.success("Course deleted successfully");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to delete course");
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return isNaN(d.getTime())
      ? "N/A"
      : d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
  };

  /* ================= ERROR HANDLING ================= */
  useEffect(() => {
    if (isError) {
      if (error?.status === 401) {
        toast.error("Session expired. Please login again.");
        navigate("/login");
      } else {
        toast.error(error?.data?.message || "Failed to load courses");
      }
    }
  }, [isError, error, navigate]);

  /* ================= RENDER ================= */
  return (
    <div className="flex-1 p-6 bg-background min-h-screen">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
        <h2 className="text-3xl font-semibold">📚 All Courses</h2>
        <Button onClick={() => navigate("/admin/courses/create")} className="flex items-center gap-2">
          <Plus size={18} />
          Create New Course
        </Button>
      </div>

      <Input
        type="text"
        placeholder="Search by title or slug..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="mb-6 max-w-md"
      />

      {isError ? (
        <div className="text-center py-12">
          <p className="text-red-600 text-lg mb-4">Failed to load courses</p>
          <Button onClick={() => window.location.reload()} variant="outline">
            Retry
          </Button>
        </div>
      ) : (isLoading || isFetching) ? (
        <div className="flex items-center justify-center py-12 gap-3 text-muted-foreground">
          <Loader2 className="w-6 h-6 animate-spin" />
          Loading courses...
        </div>
      ) : sortedCourses.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          📭 No courses found
        </div>
      ) : (
        <Table>
          <TableCaption>A list of all your courses</TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead
                className="cursor-pointer select-none"
                onClick={() => toggleSort("title")}
              >
                Title {sortBy === "title" && (sortOrder === "asc" ? <ArrowUp className="inline w-4 h-4" /> : <ArrowDown className="inline w-4 h-4" />)}
              </TableHead>
              <TableHead
                className="cursor-pointer select-none"
                onClick={() => toggleSort("slug")}
              >
                Slug {sortBy === "slug" && (sortOrder === "asc" ? <ArrowUp className="inline w-4 h-4" /> : <ArrowDown className="inline w-4 h-4" />)}
              </TableHead>
              <TableHead
                className="cursor-pointer select-none"
                onClick={() => toggleSort("status")}
              >
                Status {sortBy === "status" && (sortOrder === "asc" ? <ArrowUp className="inline w-4 h-4" /> : <ArrowDown className="inline w-4 h-4" />)}
              </TableHead>
              <TableHead
                className="cursor-pointer select-none"
                onClick={() => toggleSort("updatedAt")}
              >
                Last Updated {sortBy === "updatedAt" && (sortOrder === "asc" ? <ArrowUp className="inline w-4 h-4" /> : <ArrowDown className="inline w-4 h-4" />)}
              </TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {sortedCourses.map((course) => (
              <TableRow
                key={course._id || course.slug}
                onClick={() => navigate(`/admin/courses/${course.slug}/edit`)}
                className="hover:bg-accent/50 cursor-pointer transition-colors"
              >
                <TableCell className="font-medium max-w-xs truncate">
                  {course.title || "Untitled Course"}
                </TableCell>
                <TableCell className="text-muted-foreground font-mono text-sm">
                  {course.slug || "—"}
                </TableCell>
                <TableCell>
                  <Badge
                    variant={course.status === "published" ? "default" : "secondary"}
                    className={
                      course.status === "published"
                        ? "bg-green-600 hover:bg-green-600"
                        : "bg-yellow-500 hover:bg-yellow-500"
                    }
                  >
                    {course.status === "published" ? "Published" : "Draft"}
                  </Badge>
                </TableCell>
                <TableCell>{formatDate(course.updatedAt)}</TableCell>
                <TableCell className="text-right" onClick={(e) => e.stopPropagation()}>
                  <div className="flex gap-2 justify-end">
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => navigate(`/admin/courses/${course.slug}/edit`)}
                      title="Edit Course"
                    >
                      <Edit size={18} />
                    </Button>

                    <Button
                      variant="outline"
                      size="icon"
                      onClick={(e) => handlePreview(e, course)}
                      title="Preview Course"
                    >
                      <Eye size={18} />
                    </Button>

                    <Button
                      variant="destructive"
                      size="icon"
                      onClick={(e) => handleDelete(e, course.slug)}
                      disabled={isDeleting}
                      title="Delete Course"
                    >
                      <Trash2 size={18} />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default CoursesList;